import * as R from 'ramda'
import purchaseReqInstallClient from './purchaseReq/installClient.js'
import purchaseOrderInstallClient from './purchaseOrder/installClient.js'
import arrivalProcessInstallClient from './arrivalProcess/installClient.js'
import referenceQueryInstallClient from './referenceQuery/installClient.js'

// install UI
export default R.pipe(
  purchaseReqInstallClient,
  purchaseOrderInstallClient,
  arrivalProcessInstallClient,
  referenceQueryInstallClient,
)
